import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosPagoFichaComponent {
  data
  guardando = false
  onClose
  solicitudId

  constructor (ViaticosPagosPagoService, ViaticosPermisosService, $q) {
    this.ViaticosPagosPagoService = ViaticosPagosPagoService
    this.ViaticosPermisosService = ViaticosPermisosService
    this.$q = $q
  }

  $onInit () {
    // todo: modificar este componente cuando se haga lo de las nominas para pagar
    this.promise = this.$q.all({
        pago: this.ViaticosPagosPagoService.get(this.solicitudId),
        permisos: this.ViaticosPermisosService.get(),
      })
      .then(({pago, permisos}) => {
        this.pago = pago.data
        this.permisos = permisos.data
      })
  }

  cancelar () {
    this.onClose()
  }
}

module.component('viaticosPagosPagoFicha', {
  controller: ViaticosPagosPagoFichaComponent,
  template,
  bindings: {
    data: '<',
    solicitudId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/pago/ficha/component.js